import { parseBeachPopVariant, type BeachPopVariant } from "./variantName";

export type { BeachPopVariant };
export { parseBeachPopVariant };

/** Compile-time variant. Public builds tree-shake PWA registration and install UI. */
export const BEACH_POP_VARIANT: BeachPopVariant = parseBeachPopVariant(import.meta.env.VITE_BEACH_POP_VARIANT);

export const PWA_ENABLED = BEACH_POP_VARIANT === "private-test";
